import type { CalculatorGroup, ChallengeRoute, Volume } from '../types/kit';

export const checkoutUrl = 'https://ingresos-online-argentina.impultienda.ar/checkout';
export const price = '$16.990';
export const originalPrice = '$96.990';
export const discountLabel = '82% OFF';
export const offerDurationHours = 24;

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/435ff245-2b29-4cd2-97fa-656df1c500b4.jpg',
  mercadoPago: 'https://cdn.magicpatterns.com/uploads/2N8g1Y1q9gk5fo8SMaSH4P/MP.webp',
  bonus: 'https://cdn.magicpatterns.com/uploads/ws961pVsoG5vkbtsXwEnBN/Imagen_bonos.webp',
};

export const noiseOptions = [
  'Dropshipping',
  'Trading',
  'Freelancing',
  'Cursos',
  'Agencias',
  'Inteligencia artificial',
  'Criptomonedas',
  'Ecommerce',
  'Afiliados',
  'YouTube',
];

export const models = [
  {
    accent: 'airbnb' as const,
    name: 'Airbnb',
    href: '#volumen-1',
    description:
      'Cómo construir un negocio gestionando propiedades de terceros sin necesidad de comprar un departamento.',
  },
  {
    accent: 'arbitraje' as const,
    name: 'Arbitraje',
    href: '#volumen-2',
    description:
      'Cómo funciona el negocio de comprar y vender activos digitales aprovechando diferencias de precio, y qué infraestructura necesitás para profesionalizar la operatoria.',
  },
  {
    accent: 'digital' as const,
    name: 'Productos digitales',
    href: '#volumen-3',
    description:
      'Cómo detectar oportunidades, crear ebooks y otros recursos digitales utilizando IA y venderlos mediante publicidad online.',
  },
];

export const volumes: Volume[] = [
  {
    id: 'volumen-1',
    number: 1,
    accent: 'airbnb',
    title: 'Airbnb',
    subtitle: 'De propiedades ajenas a ingresos en dólares',
    cover: 'https://cdn.magicpatterns.com/uploads/wepRRXaoUz8TT7VFGQURsp/Imagen_VOL1.webp',
    intro: [
      'Existe una forma de entrar al negocio de alquileres temporarios sin tener cientos de miles de dólares para comprar una propiedad.',
    ],
    highlight: 'Administrar la de otra persona.',
    flow: ['Un propietario aporta el inmueble.', 'Vos aportás la gestión.', 'Y cobrás una comisión.'],
    learnLabel: 'Dentro de este volumen vas a aprender:',
    topics: [
      'Cómo funciona el modelo de administración de propiedades.',
      'Cómo elegir una zona.',
      'Cómo analizar el mercado.',
      'Cómo construir tu servicio.',
      'Cómo definir una comisión.',
      'Cómo conseguir propietarios mediante Meta Ads.',
      'Cómo transformar consultas en reuniones.',
      'Cómo presentar una propuesta.',
      'Cómo gestionar huéspedes, check-in, limpieza y mantenimiento.',
      'Cómo organizar precios y reservas.',
      'Cómo sistematizar la operación.',
      'Cómo empezar a delegar.',
      'Cómo funciona el modelo Rent to Rent para una etapa posterior.',
    ],
    goalLabel: 'Tu objetivo:',
    goal: 'Pasar de cero propiedades a construir una cartera de clientes.',
  },
  {
    id: 'volumen-2',
    number: 2,
    accent: 'arbitraje',
    title: 'Arbitraje',
    subtitle: 'Convertí capital en una herramienta de trabajo',
    cover: 'https://cdn.magicpatterns.com/uploads/wMVn3Px8QrnywzNFNwBUZG/Imagen_VOL2.webp',
    intro: [
      'El arbitraje no consiste simplemente en “comprar barato y vender caro”.',
      'Cuando se profesionaliza aparecen:',
    ],
    chips: [
      'plataformas',
      'spreads',
      'comisiones',
      'liquidez',
      'clientes',
      'documentación',
      'seguridad',
      'cuentas',
      'gestión del riesgo',
    ],
    learnLabel: 'En esta guía vas a aprender:',
    topics: [
      'Cómo funciona el arbitraje USDT/ARS.',
      'Qué es realmente el spread.',
      'Diferencia entre spread bruto y neto.',
      'Cómo calcular una operación.',
      'Binance P2P.',
      'Bybit P2P.',
      'OKX P2P.',
      'Cómo funciona una estrategia multiplataforma.',
      'Cómo registrar correctamente las operaciones.',
      'Cómo medir volumen y rentabilidad.',
      'El papel de los clientes recurrentes.',
      'Cómo funcionan las mesas OTC.',
      'La importancia del origen de fondos.',
      'Documentación y trazabilidad.',
      'Riesgos operativos.',
      'Seguridad.',
      'Cómo pensar el crecimiento de una operación.',
    ],
    goalLabel: 'El objetivo no es simplemente mover plata.',
    goal: 'Es construir una operatoria medible, documentada y sostenible.',
  },
  {
    id: 'volumen-3',
    number: 3,
    accent: 'digital',
    title: 'Productos digitales',
    subtitle: 'De una idea a un producto que el mercado pueda comprar',
    cover: 'https://cdn.magicpatterns.com/uploads/1pkCNc5tf7zwEcKYuDeUj4/Imagen_VOL3.webp',
    intro: [
      'Un ebook puede crearse una vez. Y venderse muchas veces.',
      'No necesitás stock. No necesitás logística física.',
      'Y hoy la inteligencia artificial permite producir y testear ideas muchísimo más rápido.',
    ],
    contrast: { before: 'hacer un PDF', after: 'crear un producto que alguien quiera comprar' },
    learnLabel: 'Por eso vas a aprender:',
    topics: [
      'Cómo investigar oportunidades en la Biblioteca de Anuncios de Meta.',
      'Cómo detectar ofertas que llevan tiempo publicitándose.',
      'Cómo elegir un problema.',
      'Cómo investigar competidores sin copiarlos.',
      'Cómo utilizar ChatGPT o Claude para desarrollar contenido.',
      'Cómo crear el producto con Gamma.',
      'Cómo construir una oferta.',
      'Cómo agregar bonos.',
      'Cómo crear una landing.',
      'Cómo configurar un checkout.',
      'Cómo cobrar inicialmente en Argentina.',
      'Cómo crear anuncios.',
      'Cómo lanzar Meta Ads.',
      'Cómo interpretar CTR, CPC, CPA y ROAS.',
      'Cómo saber cuándo mejorar un producto.',
      'Cómo saber cuándo descartarlo.',
      'Cómo escalar cuando encontrás algo que funciona.',
    ],
    goalLabel: 'No te enamores de tu producto.',
    goal: 'Enamorate del proceso de encontrar ganadores.',
  },
];

export const arsenalItems = [
  'Herramientas para Airbnb.',
  'Plataformas para arbitraje.',
  'Herramientas para productos digitales.',
  'Inteligencias artificiales.',
  'Recursos gratuitos.',
  'Herramientas pagas.',
  'Para qué sirve cada una.',
  'Cuándo tiene sentido pagar.',
  'Stack mínimo recomendado para cada negocio.',
];

export const challengeRoutes: ChallengeRoute[] = [
  { accent: 'airbnb', name: 'Ruta Airbnb', goal: '30 días para avanzar hacia tu primer propietario.' },
  { accent: 'arbitraje', name: 'Ruta Arbitraje', goal: '30 días para construir las bases de tu operatoria.' },
  { accent: 'digital', name: 'Ruta Productos Digitales', goal: '30 días para investigar, crear y lanzar tu primer producto.' },
];

export const challengeIncludes = [
  'Test de elección.',
  '3 planes de acción.',
  'Actividades diarias.',
  'Checklists.',
  'Objetivos semanales.',
  'Evaluación final.',
];

export const calculators: CalculatorGroup[] = [
  {
    accent: 'airbnb',
    model: 'Airbnb',
    items: ['Ingreso por propiedad', 'Comisiones', 'Cantidad de propiedades necesarias', 'CAC', 'Costos', 'Rentabilidad estimada'],
  },
  {
    accent: 'arbitraje',
    model: 'Arbitraje',
    items: ['Spread', 'Comisiones', 'Resultado por operación', 'Volumen', 'ROI', 'Resultado neto'],
  },
  {
    accent: 'digital',
    model: 'Productos digitales',
    items: ['CPC', 'CPA', 'Conversión', 'ROAS', 'Punto de equilibrio', 'Margen', 'Rentabilidad'],
  },
];

export const kitContents = [
  { kind: 'Volumen 1', accent: 'airbnb' as const, title: 'Airbnb', detail: 'De propiedades ajenas a ingresos en dólares' },
  { kind: 'Volumen 2', accent: 'arbitraje' as const, title: 'Arbitraje', detail: 'Cómo aprovechar oportunidades en criptomonedas' },
  { kind: 'Volumen 3', accent: 'digital' as const, title: 'Productos Digitales', detail: 'Ideas, creación y ventas paso a paso' },
  { kind: 'Bono #1', accent: null, title: 'Arsenal Digital', detail: 'Más de 30 herramientas y recursos' },
  { kind: 'Bono #2', accent: null, title: 'Desafío 30 Días', detail: 'Test de elección + 3 planes de acción' },
  { kind: 'Bono #3', accent: null, title: 'Calculadora de Negocios Online', detail: 'Los números antes de poner tu plata' },
];

export const forYou = [
  'Vivís en Argentina y querés explorar nuevas fuentes de ingresos.',
  'Querés generar plata online pero no sabés qué modelo elegir.',
  'Estás cansado de guardar videos y nunca empezar.',
  'Tenés trabajo pero querés desarrollar otra fuente de ingresos.',
  'Querés empezar un proyecto propio.',
  'Preferís tres caminos desarrollados antes que cien ideas superficiales.',
  'Estás dispuesto a aprender y ejecutar.',
  'Entendés que construir ingresos requiere tiempo, trabajo y experimentación.',
];

export const notForYou = [
  'Buscás plata automática sin trabajar.',
  'Esperás ganar USD 1.000 mañana.',
  'Querés una fórmula secreta.',
  'No estás dispuesto a probar, equivocarte y mejorar.',
  'Pensás que comprar una guía garantiza resultados.',
];

export const modelFit = [
  { accent: 'airbnb' as const, profile: 'Si tenés capacidad comercial y organizativa', model: 'Airbnb', verdict: 'puede resultarte atractivo.' },
  { accent: 'arbitraje' as const, profile: 'Si tenés capital y te gustan los números', model: 'Arbitraje', verdict: 'puede interesarte más.' },
  { accent: 'digital' as const, profile: 'Si sos creativo y te atrae el marketing', model: 'Productos digitales', verdict: 'puede encajar mejor.' },
];

export const distractions = ['Otro video.', 'Otro hilo.', 'Otro influencer.', 'Otra idea.', 'Otro negocio.'];

export const firstResults = ['tu primer propietario', 'tu primera operación rentable', 'tu primera venta digital'];
export const growthSteps = ['Después viene la segunda.', 'Después aprendés.', 'Después mejorás.', 'Después escalás.'];

export const thirtyDayOutcomes = [
  'investigado un mercado',
  'creado una oferta',
  'hablado con propietarios',
  'realizado operaciones',
  'creado un producto',
  'lanzado anuncios',
  'conseguido datos',
  'cometido errores',
];

export const closingSteps = ['Elegí una.', 'Ejecutala.', 'Medí.', 'Mejorá.'];
